import { DesignationOption } from '@/types';

export const STEP_IDS = {
  introduction: 'introduction',
  isDesignated: 'isDesignated',
  nonDesignatedRegion: 'nonDesignatedRegion',
  designationTypes: 'designationTypes',
  disclaimer: 'disclaimer',
  canCpaProvinces: 'canCpaProvinces',
  canCpaYear: 'canCpaYear',
  usaCpaStates: 'usaCpaStates',
  usaEaNumber: 'usaEaNumber',
  bmuCpaYear: 'bmuCpaYear',
  name: 'name',
  b2cJobDetails: 'b2cJobDetails',
} as const;

export type StepId = (typeof STEP_IDS)[keyof typeof STEP_IDS];

export interface ExtraInfo {
  isB2CUser: boolean;
  disclaimerDesignationOptions?: DesignationOption[];
}

export type StepConfig = {
  id: StepId;
  initialInput: any;
  isRequired?: (
    // Step is assumed to be required if function is not supplied
    form: OnboardingForm,
    options?: ExtraInfo,
  ) => boolean;
  handleNext: (form: OnboardingForm, input?: any) => OnboardingForm;
  isSubmitAllowed?: (input: any) => boolean;
  isStepInputValid: (input: any) => boolean;
};

export type RegionMap = Record<string, boolean>;

export interface CanCpa {
  provinces: RegionMap;
  year: number;
}

export interface UsCpa {
  states: RegionMap;
}

type Designation = CanCpa | UsCpa | string | boolean;

type Designations = Record<string, Designation>;

export type DesignationsForm = Record<string, Designations>;

export interface NameFields {
  first: string;
  last: string;
}

export interface JobDetails {
  companyName: string;
  jobTitle: string;
}

export interface OnboardingForm {
  isTeamUse: boolean | null;
  designations: DesignationsForm | null;
  name: NameFields | null;
  userCountry: string | null;
  jobDetails: JobDetails | null;
}

export interface OnboardingState {
  isHandlingStepTransition: boolean;
  form: OnboardingForm;
  activeStep: StepId;
  stepInputs: Record<StepId, { value: any; error?: boolean }>;
}
